import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_STATE = {
  data: [],
  filterBy: null,
};

export const entitiesSlice = createSlice({
  name: "entities",
  initialState: INITIAL_STATE,
  reducers: {
    resetEntities: () => INITIAL_STATE,
    setFilterBy: (state, { payload }) => {
      state.filterBy = payload ?? null;
    },
    setEntities: (state, { payload = [] }) => {
      state.data = payload;
    },
  },
});

export const { resetEntities, setEntities, setFilterBy } =
  entitiesSlice.actions;
